import { inject, Injectable } from '@angular/core';
import { CtBatchStoreService } from './app-state/ct-batch-store.service';
import { ct2ConfigurationByBatchDomain } from '../models/extraction-models/extraction-models';
import { CtDocument, DocumentClassKey } from '@ps-gui/claims-terminal-shared';
import { sortBy } from '@vydaps/gui-commons/arrays';

@Injectable({
  providedIn: 'root',
})
export class ConsolidationService {
  private readonly ctBatchStoreService = inject(CtBatchStoreService);
  private readonly config = ct2ConfigurationByBatchDomain[this.ctBatchStoreService.ctBatchDomain];

  private readonly consolidationPriorityClasses: DocumentClassKey[] = [
    '25_Q3_FORDERUNGSSCHREIBEN',
    '25_Q3_FORDERUNGSAUFSTELLUNG',
    'BEAUFTRAGUNGSMAIL',
    '25_Q3_AUFTRAGSFORMULAR_PROOF',
  ];

  getConsolidationDocumentsBySplitDocumentId(splitDocumentId: string | undefined): CtDocument[] {
    const splitDocument = splitDocumentId
      ? this.ctBatchStoreService.getDocumentById(splitDocumentId)
      : undefined;
    const otherDocuments = this.ctBatchStoreService.ctBatch.documents.filter(
      (document) =>
        !document.documentClasses.includes(
          this.config.batchSplitConfiguration?.splitInducingDocumentClass,
        ),
    );

    return (splitDocument ? [splitDocument] : []).concat(otherDocuments);
  }

  sortDocumentsByConsolidationPriority(documents: CtDocument[]) {
    const getPriorityForClass = (documentClass: DocumentClassKey) => {
      if (documentClass === '25_Q3_SONSTIGES') return Number.MAX_VALUE;
      const index = this.consolidationPriorityClasses.indexOf(documentClass);
      return index > -1 ? index : Number.MAX_VALUE - 1;
    };

    const getPriorityForDocument = (document: CtDocument) => {
      return Math.min(
        ...document.documentClasses.map((documentClass) => getPriorityForClass(documentClass)),
      );
    };

    const priorityByDocument = new Map<CtDocument, number>();
    documents.forEach((document) =>
      priorityByDocument.set(document, getPriorityForDocument(document)),
    );

    return sortBy(documents, (document) => priorityByDocument.get(document)!);
  }
}
